import { Dictionary } from '@reduxjs/toolkit';
import IProcedureDetail from 'api/models/procedure-details.model';
import { LoadingStatus } from 'interfaces/loading-statuses';

// Initial state definition and type

type ProcedureDetailsState = {
    loading: LoadingStatus;
    data: Dictionary<IProcedureDetail>;
    loadingProcedureDetail: LoadingStatus;
    selectedProcedureDetail?: IProcedureDetail;
    savingProcedureDetail: LoadingStatus;
    procedureDetailsSearch?: string;
    error?: string;
    excelDataUploaded?: boolean;
    excelDataUploading: LoadingStatus;
    isProcedureActive: boolean;
};

export const initialProcedureDetailsState: ProcedureDetailsState = {
    data: {},
    loading: LoadingStatus.Idle,
    loadingProcedureDetail: LoadingStatus.Idle,
    savingProcedureDetail: LoadingStatus.Idle,
    excelDataUploading: LoadingStatus.Idle,
    isProcedureActive: true,
};

export default ProcedureDetailsState;
